import React, { useContext, useEffect, useState } from 'react';
import { ListItem, ListItemContent, Box, CircularProgress } from "@mui/joy";
import { Button } from '../Button';

import { useTranslation } from 'react-i18next'
import PersonAvatar from '../Snippet/PersonAvatar';
import { Icon } from '../../assets';
import { useDrawer } from '../Drawer'
import { Tag } from '../Snippet';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const collectShopIds = (employment) => [
    ...(employment.agent_of_shop_ids || []),
    ...(employment.leader_of_shop_ids || []),
    ...(employment.assistant_of_shop_ids || []),
    ...(employment.shop_ids || []),
    ...(employment.shops_ids || []),
].filter(Boolean);

const dedupeShops = (shopList) => {
    const byId = {};
    shopList.forEach((shop) => {
        if (!shop) return;
        const id = shop._id ?? shop.id;
        if (id) byId[String(id)] = shop;
    });
    return Object.values(byId);
};

const RelationshipEmployment = ({ k, v, name, editing, detailInspector = true, handleItemDetail, handleItemRemove, setValue, loadingDissociation }) => {
    const { t } = useTranslation();
    const { item: personLoaded, loadOne: loadOnePerson, success: successPerson, loading: loadingPerson } = useDataProvider('persons/person');
    const { item: areaLoaded, loadOne: loadOneArea, loading: loadingArea } = useDataProvider('commercials/area');
    const { items: shopsLoaded, loadAll: loadAllShops, loading: loadingShops } = useDataProvider('commercials/shop');

    const { appConfiguration } = useContext(AppContext);

    // hack veloce per modellare v se lo ricevo dalla scheda person. Noi vogliamo un employment idratato con person ma riceviamo person
    /**
     * @todo fix this shit
     */
    if (typeof v.person_id == 'undefined' && v.employment) {
        const oldv = v;
        v = {
            ...oldv.employment,
            'person': {
                _id: oldv._id,
                firstname: oldv.firstname,
                lastname: oldv.lastname,
                picture: {
                    url: oldv?.person?.picture?.url
                }
            }
        };

        setValue('employment', v);
    }


    const [person, setPerson] = useState();
    const [area, setArea] = useState();
    const [shops, setShops] = useState();

    useEffect(() => {
        if (v.person) {
            setPerson(v.person)
        } else if (v.person_id) {
            loadOnePerson(v.person_id);
        }
    }, [v]);

    useEffect(() => {
        if (!personLoaded) return;
        setPerson(personLoaded.data);
    }, [personLoaded]);

    useEffect(() => {
        if (appConfiguration.dashboard.view != 'ConsecutionSales') return;

        if (v.area) {
            setArea(v.area);
        } else if (v.area_id) {
            setArea(null);
            loadOneArea(v.area_id);
        } else {
            setArea(null);
        }
    }, [v, appConfiguration.dashboard.view]);

    useEffect(() => {
        if (!areaLoaded?.data) return;
        setArea(areaLoaded.data);
    }, [areaLoaded]);

    useEffect(() => {
        if (appConfiguration.dashboard.view != 'ConsecutionSales') return;

        const embeddedShops = dedupeShops([
            ...(v.shops || []),
            ...(v.leaderOfShops || []),
            ...(v.agentOfShops || []),
            ...(v.assistantOfShops || []),
        ]);

        if (embeddedShops.length) {
            setShops(embeddedShops);
            return;
        }

        const shopIds = [...new Set(collectShopIds(v).map(String))];

        if (shopIds.length) {
            setShops(null);
            loadAllShops({
                items: [{
                    field: 'id',
                    operator: 'in',
                    value: shopIds,
                }],
            }, null, 1, shopIds.length);
        } else {
            setShops(null);
        }
    }, [v, appConfiguration.dashboard.view]);

    useEffect(() => {
        if (!shopsLoaded?.length) return;
        setShops(shopsLoaded);
    }, [shopsLoaded]);

    return (
        <>
            {/*
            <JSONPretty data={v} className="json-wrapper"></JSONPretty>
            <JSONPretty data={person} className="json-wrapper"></JSONPretty>
            <JSONPretty data={name} className="json-wrapper"></JSONPretty> 
            */}

            <ListItem k={k} variant="outlined" className={"relationship-element"}>
                <ListItemContent
                    className={"relationship-element-content"}
                    sx={appConfiguration.dashboard.view == 'ConsecutionSales' ? {
                        gridTemplateColumns: '260px 220px 220px 140px auto !important',
                    } : undefined}
                >
                    {
                        person ?
                            <PersonAvatar firstname={person?.firstname} lastname={person?.lastname} url={person?.picture?.url} withname={true} item={person} />
                            :
                            <Box className={"status"}>
                                <Tag color={"danger"} title={t("Missing person in employment")}><Icon icon="faWarning" />{t('Missing')}</Tag>
                            </Box>
                    }
                    {
                        appConfiguration.dashboard.view == 'ConsecutionSales' ? (
                            <>
                                <Box className="coupled">
                                    <Box className="label">{t('areas')}</Box>
                                    <Box className="value">
                                        {v?.area_id && loadingArea ? (
                                            <CircularProgress size="sm" />
                                        ) : (
                                            <span>{area?.name || '-'}</span>
                                        )}
                                    </Box>
                                </Box>
                                <Box className="coupled">
                                    <Box className="label">{t('shops')}</Box>
                                    <Box className="value">
                                        {collectShopIds(v).length > 0 && loadingShops ? (
                                            <CircularProgress size="sm" />
                                        ) : (
                                            <span>{shops?.map(shop => shop.name).filter(Boolean).join(', ') || '-'}</span>
                                        )}
                                    </Box>
                                </Box>

                                <Box className={"status"}>
                                    <Tag color={v?.status != "terminated" ? "success" : "danger"} title={t("Missing person in employment")}><Icon icon="faWarning" />{t(v?.status)}</Tag>
                                </Box>

                                <Box className={"coupled"}>
                                    <Box className="label">{t('role')}</Box>
                                    <Box className="value">{v.role ?? '-'}</Box>
                                </Box>
                            </>
                        ) : (
                            <>
                                <Box className="coupled">
                                    <Box className="label">{t('Role')}</Box>
                                    <Box className="value">
                                        <span>{v?.role}</span>
                                    </Box>
                                </Box>

                                <Box className={"status"}>
                                    <Tag color={v?.status != "terminated" ? "success" : "danger"} title={t("Missing person in employment")}><Icon icon="faWarning" />{t(v?.status)}</Tag>
                                </Box>
                            </>
                        )
                    }
                </ListItemContent>

                {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
                {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
            </ListItem>
        </>
    )
}

export default RelationshipEmployment



